export type Position = { x: number; y: number };
export const POSITION = "Position";
